module.exports = __webpack_public_path__ + "img/bg.dd4ddfd4.png";